// ============================================================================
// KLINISOL CRO - Protected Route Component
// With Viewer/Demo Mode Warning Banner
// ============================================================================

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { AlertTriangle } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading, user } = useAuth();

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontSize: '18px',
                color: '#1a5f7a'
            }}>
                Loading...
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    // Check if user is Viewer role
    const isViewer = user?.role === 'Viewer';

    return (
        <>
            {/* Persistent Warning Banner for Viewer/Demo Mode */}
            {isViewer && (
                <div className="bg-amber-50 border-b border-amber-200 px-4 py-3 sticky top-0 z-50 shadow-sm">
                    <div className="max-w-7xl mx-auto flex items-center gap-3">
                        <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0" />
                        <p className="text-sm text-amber-800">
                            <strong>Demo/Audit Mode</strong> — All actions are logged with full audit trail. 
                            For transparency purposes, you have read access to the entire platform. 
                            Please avoid making changes to preserve data integrity.
                        </p>
                    </div>
                </div>
            )}
            {children}
        </>
    );
};

export default ProtectedRoute;
